import React from "react";
import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { FaLinkedin, FaEnvelope, FaPhone } from "react-icons/fa";

const useStyles = makeStyles((theme) => ({
  social: {
    padding: "1em",
    placeContent: "center",
  },
  icon: {
    color: "#1c4c99",
    padding: "6px",
    borderRadius: "30%",
    width: "2rem",
    height: "2rem",
    [theme.breakpoints.down("sm")]: {
      width: "1.5rem",
      height: "1.5rem",
    },
    "&:hover": {
      boxShadow: "0px 0px 10px 2px #ff7701",
    },
  },
}));

const SocialLinks = () => {
  const classes = useStyles();

  const social = [
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/in/g-singarajan-614a3129",
      icon: <FaLinkedin className={classes.icon} />,
    },
    {
      name: "Mail",
      href: "mailto:gsingarajan@yahoo.com?subject=via%20Portfolio",
      icon: <FaEnvelope className={classes.icon} />,
    },
    {
      name: "Mobile",
      href: "tel:9383468103",
      icon: (
        <FaPhone
          className={classes.icon}
          style={{ transform: "rotate(90deg)" }}
        />
      ),
    },
  ];
  return (
    <Grid container spacing={3} className={classes.social}>
      {social.map((s, idx) => (
        <Grid item key={idx} xs={4} sm={3} md={2} xl={1}>
          <a href={s.href} target="_blank" rel="noreferrer">
            <span title={s.name}>{s.icon}</span>
          </a>
        </Grid>
      ))}
    </Grid>
  );
};

export default SocialLinks;
